import { Component, OnInit } from '@angular/core';
import { fadeInOut } from '../../shared/helpers/animations';
import { AuthenticationService } from '../../shared/services';

@Component({
    selector: 'app-accessdenied',
    templateUrl: './accessdenied.component.html',
    styleUrls: ['./accessdenied.component.scss'],
    animations: [fadeInOut],
    standalone: false
})

export class AccessdeniedComponent implements OnInit {
  hasApplicationPermission: boolean;
  message: string;

  constructor(private authenticationService: AuthenticationService) { }

  // wam-sso: an unmapped SSO user lands here with no nav/user info showing, so give them an explicit way to
  // sign out — otherwise there is no logout affordance and they are stuck.
  logout(): void {
    this.authenticationService.logout();
  }

  ngOnInit(): void {
    // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }
}
